import { useContext } from "react";
import { ErrorDialogContext, errorHandledAsync } from "@/shared/context/error-context";
import { GetUsersService } from "@/features/user/services/get-users-service";


export const useGetUsers = () => {
  const getUsersService = new GetUsersService();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const getUsers = async () => {
    try {
      const res = await getUsersService.getUsers({});
      return res;
    } catch (error) {
      // エラー
      console.log("getUsers", error);
      // throw error;  // APIエラーとなっても処理に影響はなさそうなので一旦コメントアウト
    } finally {
      //
    }
  };

  return {
    getUsers: errorHandledAsync(getUsers, setError),
  };
};
